exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js??ref--8-oneOf-1-1!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/postcss-loader/src/index.js??ref--8-oneOf-1-2!bootstrap/dist/css/bootstrap.css"), "");

// module
exports.push([module.id, ".cell-single-hierachy[data-v-a753c462]{font-size:19px;line-height:35px}.cell-single-hierachy[data-v-a753c462],.cell-single-hierachy *[data-v-a753c462]{display:inline-flex;align-items:center}", ""]);

// exports
